@if (mergeMode) {
  <div class="fixed inset-0 bg-white/90 z-10 pointer-events-auto"></div>
}

@if (mergeMode) {
  <div class="fixed top-[40px] left-0 w-full z-[1000] p-2">
    <div class="flex items-center justify-center gap-2">
      <p-button
        label="{{ 'contacts.cancel' | transloco }}"
        icon="pi pi-times"
        [text]="true"
        (click)="toggleMergeMode()"
      />
      <p-button
        [label]="
          selectedMergeContacts.length +
          ' ' +
          ('contacts.mergeContatcs' | transloco)
        "
        icon="pi pi-check"
        (click)="startMerge()"
        [disabled]="selectedMergeContacts.length < 2"
      />
    </div>
  </div>
}

<div class="z-[11] relative">
  <div class="h-[70vh] flex flex-col min-h-0">
    <div class="flex-shrink-0">
      <div class="flex flex-wrap justify-between items-center gap-4 mb-2">
        <div class="flex items-center relative flex-1 min-w-[200px]">
          <input
            type="text"
            pInputText
            [value]="searchText"
            (input)="onSearchChange($event)"
            placeholder="{{ 'contacts.searchContact' | transloco }}"
            spellcheck="false"
            autocomplete="off"
            class="w-full pr-8 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          @if (searchText) {
            <i
              class="pi pi-times absolute right-2 cursor-pointer text-gray-400 hover:text-gray-700"
              (click)="clearSearch()"
            ></i>
          }
        </div>
        <div class="flex gap-2 flex-wrap">
          <p-button
            [label]="'contacts.mergeContatcs' | transloco"
            icon="pi pi-link"
            styleClass="p-button-warning"
            (click)="toggleMergeMode()"
            [disabled]="mergeMode"
          />

          <p-button
            [label]="(onlyVeterinarians ? 'contacts.createNewVeterinarian' : 'contacts.createNewContact') | transloco"
            iconPos="left"
            icon="pi pi-plus"
            class="p-button-rounded"
            data-cy="contact-create"
            (click)="toggleCreateContact(true)"
            [disabled]="mergeMode"
          ></p-button>
        </div>
      </div>

      <app-alphabet-filter
        [alphabet]="alphabet"
        [groups]="groupedContacts"
        [selectedLetter]="selectedLetter"
        [disabled]="searchedContacts.length > 0"
        (letterSelected)="filterByLetter($event)"
      />
    </div>

    <div class="flex flex-col flex-1 min-h-0">
      <div class="flex-shrink-0 bg-primary-600 text-white font-bold px-4 py-2 rounded mb-1 text-sm">
        <div class="flex">
          <span class="flex-1 text-left">{{ 'contacts.gender' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.title' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.lastName' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.firstName' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.company' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.street' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.city' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.zipCode' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.birthday' | transloco }}</span>
          <span class="flex-1 text-left">{{ 'contacts.birthPlace' | transloco }}</span>
          <span class="flex-1"></span>
        </div>
      </div>
      @if (isLoading) {
        <div class="flex w-full items-center justify-center gap-2 py-2 text-gray-500">
          <i class="pi pi-spinner pi-spin"></i>
          <span>Kontakte werden geladen...</span>
        </div>
      }
      <div class="flex-1 min-h-0 flex flex-col">
        <p-scroller
            #scroller
            [items]="visibleContacts"
            [itemSize]="48"
            [trackBy]="trackByContact"
            class="flex-1 min-h-0 h-full block"
            [style]="{ height: '100%' }"
        >
          <ng-template let-contact pTemplate="item">
            <div
              class="flex items-center h-12 gap-2 px-4 border-b border-gray-100 text-sm transition-colors duration-200 cursor-pointer
              hover:bg-gray-50
            "
              [ngClass]="{
              'bg-(--p-secondary-500)': highlightedContactId === contact.id || isSelected(contact)
            }"
              [id]="'contact-' + contact.id"
              (click)="openContactDetails(contact)"
            >
              <i class="pi pi-user text-primary-600 text-lg flex-shrink-0"></i>
              <span class="flex-1 text-left">
                {{ contact.gender ? ('salutation.' + contact.gender | transloco) : '-' }}
              </span>
              <span class="flex-1 text-left">{{ contact.title || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.lastName || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.firstName || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.companyName || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.street || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.city || '-' }}</span>
              <span class="flex-1 text-left">{{ contact.zipCode || '-' }}</span>
              <span class="flex-1 text-left">{{
                      contact.birthday ? (contact.birthday | date : 'dd.MM.yyyy') : '-'
                }}</span>
              <span class="flex-1 text-left">{{ contact.birthPlace || '-' }}</span>
              <span
                class="flex-1 flex justify-end cursor-pointer"
                (click)="toggleEditContact($event, true, contact)"
              ><i class="pi pi-pen-to-square"></i
              ></span>
            </div>
          </ng-template>
        </p-scroller>
      </div>
    </div>
  </div>

  <p-dialog
    [(visible)]="openCreateContactModal"
    [style]="{ width: '90vw', height: '90vh' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="toggleCreateContact(false)"
  >
    <ng-template pTemplate="header">
      <h3>{{ 'animalAdd.origin.edit' | transloco }}</h3>
    </ng-template>
    <ng-template pTemplate="content">
      <app-choose-contact
        [onlyCreateContact]="true"
        [presetVeterinary]="onlyVeterinarians"
        [newContact]="newContact"
        (newContactUpdated)="onSetNewContact($event)"
        (validationStatusChanged)="validationStatusChanged = $event"
      />
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex">
        <div class="flex-1">
          <p-button
            (click)="toggleCreateContact(false)"
            icon="pi pi-times"
            [text]="true"
            label="{{ 'modal.cancel' | transloco }}"
          />
          <p-button
            data-cy="contact-create-save"
            (click)="saveNewContact()"
            [disabled]="!validationStatusChanged"
            icon="pi pi-save"
            label="{{ 'modal.save' | transloco }}"
          />
        </div>
      </div>
    </ng-template>
  </p-dialog>
  <p-dialog
    [(visible)]="openEditContactModal"
    [style]="{ width: '90vw', height: '90vh' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="toggleEditContact($event, false)"
  >
    <ng-template pTemplate="header">
      <h3>{{ 'animalAdd.origin.edit' | transloco }}</h3>
    </ng-template>
    <ng-template pTemplate="content">
      <app-choose-contact
        [onlyEditContact]="true"
        [newContact]="newContact"
        (newContactUpdated)="onSetNewContact($event)"
        (validationStatusChanged)="validationStatusChanged = $event"
      />
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex">
        <div class="flex-1">
          <p-button
            (click)="toggleEditContact($event, false)"
            icon="pi pi-times"
            [text]="true"
            label="{{ 'modal.cancel' | transloco }}"
          />
          <p-button
            (click)="saveUpdateContact()"
            [disabled]="!validationStatusChanged"
            icon="pi pi-save"
            label="{{ 'modal.save' | transloco }}"
          />
        </div>
      </div>
    </ng-template>
  </p-dialog>

  @if (openMergeModal) {
    <app-merge-contact-modal
      [visible]="openMergeModal"
      [mergedContact]="mergedContact"
      [conflictingFields]="conflictingFields"
      (merged)="onMergeConfirmed($event)"
      (canceled)="onMergeCanceled()"
    />
  }
</div>
